import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreSidebarsModule } from '@xbaht/ui/core/components/core-sidebars/core-sidebars.module';

import { NavbarsModule } from '../components/navbars/navbars.module';
import { ContentsModule } from '../components/contents/contents.module';
import { MenusModule } from '../components/menus/menus.module';
import { FootersModule } from '../components/footers/footers.module';

import { HorizontalLayoutComponent } from './horizontal/horizontal-layout.component';

@NgModule({
  declarations: [HorizontalLayoutComponent],
  imports: [
    RouterModule,
    CoreCommonModule,
    CoreSidebarsModule,
    NavbarsModule,
    ContentsModule,
    MenusModule,
    FootersModule,
  ],
  exports: [HorizontalLayoutComponent],
})
export class HorizontalLayoutModule {}
